import { render, staticRenderFns } from "./user-role-avatar.vue?vue&type=template&id=1a53e93d"
import script from "./user-role-avatar.vue?vue&type=script&lang=ts"
export * from "./user-role-avatar.vue?vue&type=script&lang=ts"
import style0 from "./user-role-avatar.vue?vue&type=style&index=0&id=1a53e93d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a53e93d')) {
      api.createRecord('1a53e93d', component.options)
    } else {
      api.reload('1a53e93d', component.options)
    }
    module.hot.accept("./user-role-avatar.vue?vue&type=template&id=1a53e93d", function () {
      api.rerender('1a53e93d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-user-role-avatar/user-role-avatar.vue"
export default component.exports